import ActiveSurfaceView from '../store/schema/ActiveSurfaceView';
import { action } from 'satcheljs';

/**
 * Changes activeSurface in surface store
 * @param newSurface, the new surface to be chosen
 */
const changeActiveSurface = action('changeActiveSurface', (newSurface: ActiveSurfaceView) => ({
    newSurface,
}));

export default changeActiveSurface;
